export default "__VITE_ASSET__239d248f__"